import './style.css';

function handleForm(event) {
  event.preventDefault();

  // Get the form type (signup or login)
  const formEl = document.querySelector('.auth-block__form');

  if (!formEl) {
    console.warn('pryvy auth: no form found');
    return;
  }

  const hostname = formEl.getAttribute('data-hostname') ?? 'https://app.pryvy.io';
  const formType = formEl.getAttribute('data-type');
  const page = formType === 'signup' ? 'signup' : 'login';

  // get the email address
  const email = document.querySelector('.auth-block__form input[name=email]').value;

  // base64 encode the email address
  const encodedEmail = btoa(email);

  // redirect to pryvy auth
  window.location.href = `${hostname}/${page}?e=${encodedEmail}`;
}

document.querySelector('.auth-block__form').addEventListener('submit', handleForm);
